import { firstVariant, secondVariant, thirdVariant, fourthVariant, fifthVariant } from '../data/russianTestData'

export const getRandomRussianTestVariant = () => {
    const russianTestVariants = [firstVariant, secondVariant, thirdVariant, fourthVariant, fifthVariant]

    const randomNumber = Math.floor(Math.random() * russianTestVariants.length)

    return russianTestVariants[randomNumber]
}